import { Field, Formik } from 'formik';
import { useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import {
  getUserTypeOptions,
  TEXTAREA_ROW_LENGTH,
} from '../../../../constants/constants';
import accountStatusEnum from '../../../../constants/enums/account-status-type-enum';
import { AccountStatusTypeOptions } from '../../../../constants/options.constant';
import { getUserType } from '../../../../helpers/localstorage-helper';
import { IBaseFactory } from '../../../../models/forms/IAddUpdateFactory';
import FormikFormInput from '../../../../shared-components/FormikFormHandlers/FormikFormInput';
import FormikFormPasswordField from '../../../../shared-components/FormikFormHandlers/FormikFormPasswordField';
import FormikFormSelect from '../../../../shared-components/FormikFormHandlers/FormikFormSelect';
import FormikFormTextArea from '../../../../shared-components/FormikFormHandlers/FormikFormTextArea';
import { FactoryUserValidationSchema } from '../../../../shared-components/FormikFormHandlers/FormikValidationSchema';
import FormLoader from '../../../../shared-components/FormLoader/FormLoader';
import Label from '../../../../shared-components/label/label';
import ModalFooter from '../../../../shared-components/modal/modal-footer';
import { formatMessage } from '../../../../translations/format-message';

interface IProps {
  id: number;
  initialValues: IBaseFactory;
  isLoading: boolean;
  next: (newData: any, final?: boolean) => void;
  prev: (newData: any) => void;
  onModalClosed: () => void;
}

export const StepUserDetails = (props: IProps) => {
  const [isEmailRequired, setIsEmailRequired] = useState(false);

  const handleFinalSubmit = (values: IBaseFactory) => {
    let finalData = {
      ...values,
    };
    props.next({ ...finalData }, true);
  };

  const handlePreviousStep = (values: IBaseFactory, isValid: boolean) => {
    if (props.id > 0) {
      if (isValid) {
        props.prev(values);
      }
    } else {
      props.prev(values);
    }
  };

  return (
    <Formik
      initialValues={props.initialValues}
      onSubmit={handleFinalSubmit}
      validationSchema={FactoryUserValidationSchema}
      validateOnBlur={false}
      enableReinitialize
    >
      {({
        values,
        isValid,
        handleSubmit,
        handleBlur,
        handleChange,
        setFieldValue,
      }) => {
        return (
          <Form
            id="formBody"
            onSubmit={handleSubmit}
          >
            {props.isLoading && <FormLoader loading={props.isLoading} />}

            <Modal.Body className="overflow-hidden">
              <div className="wizard">
                <div className="wizard-inner">
                  <div className="connecting-line"></div>
                  <ul
                    className="nav nav-tabs"
                    role="tablist"
                  >
                    <li
                      role="presentation"
                      className="active"
                    >
                      <a
                        // href="#step1"
                        data-toggle="tab"
                        aria-controls="step1"
                        role="tab"
                        aria-expanded="true"
                      >
                        <span className="round-tab">
                          <svg
                            height="16"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                            width="16"
                            xmlns="http://www.w3.org/2000/svg"
                            id="fi_2732655"
                          >
                            <path
                              clipRule="evenodd"
                              d="m20.6136 5.64877c.4199.36742.458 1.00751.0845 1.42204l-10.5139 11.66979c-.37544.4167-1.02006.4432-1.42843.0588l-6.08403-5.7276c-.37942-.3572-.41574-.9524-.09021-1.3593.3592-.449 1.02811-.5108 1.4556-.1263l4.72039 4.2459c.41022.369 1.04179.336 1.41138-.0737l9.0435-10.02691c.3659-.40576.99-.44254 1.4012-.08272z"
                              fillRule="evenodd"
                            ></path>
                          </svg>
                        </span>{' '}
                        <i>{formatMessage('factory_deails')}</i>
                      </a>
                    </li>
                    <li
                      role="presentation"
                      className="active"
                    >
                      <a
                        // href="#step2"
                        data-toggle="tab"
                        aria-controls="step2"
                        role="tab"
                        aria-expanded="false"
                      >
                        <span className="round-tab">2</span>{' '}
                        <i>{formatMessage('user_details')}</i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="border-box">
                <h6 className="border-box-heading">
                  {formatMessage('user_detail_header')}
                </h6>
                <div className="row">
                  <div className="col-12 email-active">
                    <Label
                      className="label-style"
                      required={isEmailRequired}
                      label="email"
                    />
                    <div className="input-group mb-3">
                      <Field
                        data-testid="Email"
                        className="form-control"
                        name="Email"
                        placeholder=""
                        type="text"
                        validcharacter={['@', '#', '$', '-', '_', '.']}
                        as={FormikFormInput}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        aria-describedby="basic-addon2"
                      />
                      <div className="input-group-append">
                        <span
                          className="input-group-text"
                          id="basic-addon2"
                        >
                          <Field
                            name="AccountStatus"
                            as={FormikFormSelect}
                            options={AccountStatusTypeOptions}
                            onChange={(
                              e: React.ChangeEvent<HTMLSelectElement>
                            ) => {
                              const status = parseInt(e.target.value);
                              setFieldValue('AccountStatus', status);
                              setIsEmailRequired(
                                status === accountStatusEnum.Pending
                              );
                            }}
                            className="form-control"
                          />
                        </span>
                      </div>
                    </div>
                  </div>{' '}
                  <div className="col-md-6 col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style"
                        required={true}
                        label="user_name"
                      />
                      <Field
                        data-testid="UserName"
                        className="form-control"
                        name="UserName"
                        placeholder=""
                        type="text"
                        validcharacter={['@', '#', '$', '-', '_', '.']}
                        as={FormikFormInput}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style"
                        required={true}
                        label="user_type"
                      />
                      <Field
                        name="UserType"
                        as={FormikFormSelect}
                        options={getUserTypeOptions(getUserType())}
                        disabled={true}
                        className="form-control"
                      />
                    </div>
                  </div>
                </div>{' '}
              </div>
              <div className=" mt-4 border-box mb-2">
                <h6 className="border-box-heading">
                  {formatMessage('login_detail_header')}
                </h6>
                <div className="row">
                  <div className="col-md-4 col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style"
                        required={true}
                        label="user_id"
                      />
                      <Field
                        data-testid="UserId"
                        className="form-control"
                        name="UserId"
                        placeholder=""
                        type="text"
                        validcharacter={['@', '#', '$', '-', '_', '.']}
                        as={FormikFormInput}
                        onBlur={handleBlur}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                  <div className="col-md-4 col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style"
                        required={true}
                        label="password"
                      />
                      <div className="showHideOuterDiv">
                        <Field
                          data-testid="Password"
                          className="form-control"
                          name="Password"
                          placeholder=""
                          type="text"
                          validcharacter={['@', '#', '$', '-', '_', '.']}
                          as={FormikFormPasswordField}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style"
                        required={true}
                        label="confirm_password"
                      />
                      <div className="showHideOuterDiv">
                        <Field
                          data-testid="ConfirmPassword"
                          className="form-control"
                          name="ConfirmPassword"
                          placeholder=""
                          type="text"
                          validcharacter={['@', '#', '$', '-', '_', '.']}
                          as={FormikFormPasswordField}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <div className="form-group formSet">
                  <Label
                    className="label-style"
                    required={false}
                    label="comment"
                  />
                  <Field
                    rows={TEXTAREA_ROW_LENGTH}
                    id="Comment"
                    className="form-control"
                    name="Comment"
                    placeholder=""
                    type="text"
                    as={FormikFormTextArea}
                  />
                </div>
              </div>
            </Modal.Body>

            <ModalFooter
              id={props.id}
              prev={() => handlePreviousStep(values, isValid)}
              onModalClosed={props.onModalClosed}
              isLoading={props.isLoading}
              saveNextBtn="save"
              backCancelBtn="back"
            />
          </Form>
        );
      }}
    </Formik>
  );
};
